import React from "react";
import styled from "@emotion/styled";
import loader from "src/assets/images/loader.gif";
import { mediaQuery } from "src/common";
import { Flex } from "src/components";
import { footer, header } from "src/theme";


const LoaderStyle = styled.img((props: { size: number }) => ({
  width: props.size,
  height: props.size,
}));

const FlexStyle = styled(Flex)((props: { page: boolean }) => ({
  minHeight: props.page ? `calc(100vh - ${footer.mobileHeight + header.mobileHeight + 80}px)` : 'auto',

  [mediaQuery('mobile')]: {
    minHeight: props.page ? `calc(100vh - ${footer.height + header.mobileHeight + 80}px)` : 'auto',
  },

  [mediaQuery('laptopL')]: {
    minHeight: props.page ? `calc(100vh - ${footer.height + header.height + 80}px)` : 'auto',
  },
}));

interface LoaderProps {
  size?: number;
  page?: boolean;
}

export const Loader: React.FC<LoaderProps> = ({ size = 24, page = false }) => (
  <FlexStyle justify="center" align="center" page={page}>
    <LoaderStyle src={loader} alt="loading" size={size} />
  </FlexStyle>
)


